export default __webpack_public_path__ + "static/media/BlindStateOn.05b54497.svg";